import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getProperty } from '../services/api';
import PropertySettingsTab from '../components/PropertySettingsTab';
import PropertyReferencePhotosTab from '../components/PropertyReferencePhotosTab';
import LoadingScreen from '../components/LoadingScreen';

const PropertyManagePage = () => {
  const { propertyId } = useParams();
  const navigate = useNavigate();
  const [propertyName, setPropertyName] = useState('');
  const [activeTab, setActiveTab] = useState('settings');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchName = async () => {
      try {
        const p = await getProperty(propertyId);
        if (p) setPropertyName(p.name);
      } catch (_) { /* ignore */ }
      setLoading(false);
    };
    fetchName();
  }, [propertyId]);

  if (loading) return <LoadingScreen />;

  const tabs = [
    { key: 'settings', label: 'Settings' },
    { key: 'reference', label: 'Reference Photos' },
  ];

  return (
    <div className="ayni-page" style={{ minHeight: 'calc(100vh - 40px)' }}>
      {/* Header */}
      <button className="ayni-back" onClick={() => navigate('/properties')}>
        <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15 18l-6-6 6-6"/></svg>
        Back to properties
      </button>

      <div className="ayni-toolbar" style={{ margin: '0 0 20px' }}>
        <div className="ayni-toolbar-group">
          <h1 className="ayni-display-lg" style={{ margin: 0 }}>
            {propertyName || `Property ${propertyId}`}
          </h1>
        </div>
        <div className="ayni-toolbar-group">
          <button className="ayni-btn primary" onClick={() => navigate(`/properties/${propertyId}`)}>
            View Reservations
          </button>
        </div>
      </div>

      {/* Tab Bar */}
      <div className="ayni-tabs">
        {tabs.map(tab => (
          <button
            key={tab.key}
            className={`ayni-tab ${activeTab === tab.key ? 'on' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      {activeTab === 'settings' ? (
        <PropertySettingsTab propertyId={propertyId} />
      ) : (
        <PropertyReferencePhotosTab propertyId={propertyId} />
      )}
    </div>
  );
};

export default PropertyManagePage;
